export const environment = {
  production: true,
  backendApiUrl: 'https://aims.mop.gov.so:900/api/',
};